import { io, Socket } from 'socket.io-client';
import requestConfig from '../../shared/config/request';
import { socketOptions } from './index';
import { getCurrentUserId } from '../firebase/init';

let userSocket: Socket | null = null;
let currentSocketUserId: string | null = null;

export const getUserSocket = (): Socket => {
  const userId = getCurrentUserId();

  // If socket exists for the same user, reuse it
  if (userSocket && currentSocketUserId === userId) {
    return userSocket;
  }

  // If socket exists for a different user, disconnect it
  if (userSocket) {
    userSocket.disconnect();
  }

  userSocket = io(`${requestConfig.socketUrl}/user`, {
    ...socketOptions,
    query: { userId },
  });

  currentSocketUserId = userId ?? null;

  userSocket.on('connect', () => {
    document.dispatchEvent(new CustomEvent('user-socket-connect'));
  });
  userSocket.on('disconnect', (reason) => {});

  return userSocket;
};
